import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IdmOption } from '../profile/models/idm-option';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { BrowserCompatibilityCheckService } from './browser-compatibility-check.service';

const redirectUrl: string = 'redirectUrl';

@Injectable({
    providedIn: 'root',
})
export class LoginRedirectionService {
    idmOption: IdmOption;

    constructor(
        private router: Router,
        private localStorageService: LocalStorageService,
        private browserCompatibilityCheckService: BrowserCompatibilityCheckService
    ) {}

    setIdmOptions(idmOption: IdmOption) {
        this.idmOption = idmOption;
    }

    login(url: string): void {
        if (url) {
            this.setRedirectUrl(url);
        }
        this.browserCompatibilityCheckService.markCompatibilityCheckPending();
        this.redirect(this.idmOption.loginUri);
    }

    signup(): void {
        this.setRedirectUrl(this.router.url);
        this.browserCompatibilityCheckService.markCompatibilityCheckPending();
        this.redirect(this.idmOption.registrationUri);
    }

    redirect(url: string): void {
        window.location.assign(url);
    }

    setRedirectUrl(url: string): void {
        this.localStorageService.setItem(redirectUrl, url);
    }

    getRedirectUrl(): string {
        return this.localStorageService.getItem(redirectUrl);
    }

    removeRedirectUrl(): void {
        this.localStorageService.removeItem(redirectUrl);
    }

    changePassword(): void {
        this.redirect(this.idmOption.changePasswordUri);
    }
}
